import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import AboutSkill from './Aboutskill';
import "../about.css";

export default function AboutPage() {
  const [isClient, setIsClient] = useState(false);
  const [hoveredLeft, setHoveredLeft] = useState(false);
  const [hoveredRight, setHoveredRight] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleMouseEnter = (side) => {
    if (side === 'left') setHoveredLeft(true);
    else setHoveredRight(true);
  };

  const handleMouseLeave = (side) => {
    if (side === 'left') setHoveredLeft(false);
    else setHoveredRight(false);
  };

  return (
    <div className="min-h-screen bg-black text-gray-100 py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
      <motion.h1
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-2xl font-semibold sm:text-4xl md:text-6xl  text-center mb-8 sm:mb-12"
      >
        ABOUT
      </motion.h1>

      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="max-w-7xl mx-auto bg-black rounded-lg shadow-lg overflow-hidden"
      >
        <div className="flex flex-col lg:flex-row items-center justify-between p-4 sm:p-8 space-y-8 lg:space-y-0 lg:space-x-8">
          {/* Left Image Section */}
          <div className="w-full sm:w-2/3 lg:w-1/3 perspective mx-auto lg:mx-0">
            {isClient && (
              <div
                className="relative w-full pb-[100%] sm:pb-[75%] lg:pb-[100%] golden-glow"
                onMouseEnter={() => handleMouseEnter('left')}
                onMouseLeave={() => handleMouseLeave('left')}
              >
                <motion.img
                  src="https://images.unsplash.com/photo-1721332153370-56d7cc352d63?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Team member 1"
                  className={`absolute inset-0 rounded-lg shadow-md w-full h-full object-cover transition-transform duration-500 ${
                    hoveredLeft ? 'transform-3d-hover' : 'transform-3d-default'
                  }`}
                />
              </div>
            )}
          </div>

          {/* Text Section */}
<div className="w-full lg:w-1/2 p-4 sm:p-8 rounded-3xl justify-items-center shadow-inner text-center lg:text-left gradient-bg">
  <h2 className="text-2xl sm:text-3xl font-semibold mb-4 text-center hover:text-blue-500 transition duration-300 ease-in-out">
    Brief
  </h2>
  <p className="mb-4 hover:bg-gray-600 p-2 sm:p-4 rounded transition duration-300 transform hover:scale-105 hover:shadow-lg">
  I see design as more than just visuals; it's about creating an experience that feels natural and intuitive. When I visualize a project, I start with a clear mental image of how everything should look and flow. I imagine the colors, layout, and interactions, always thinking about how the user will engage with it. My goal is to take these abstract ideas and bend them into something tangible—something that’s not only functional but also visually engaging.


  </p>
  <p className="hover:bg-gray-600 p-2 sm:p-4 rounded transition duration-300 transform hover:scale-105 hover:shadow-lg">
  I love the process of turning a raw idea into a polished product. It's like shaping clay, where every detail matters, and with the right tools and approach, I can mold it into a design that not only looks good but works seamlessly. My creativity isn’t just about making things look great; it’s about bringing order to complexity and making sure the end result is something that users enjoy and find intuitive.
  </p>
  
</div>


          {/* Right Image Section */}
          <div className="w-full sm:w-2/3 lg:w-1/3 perspective mx-auto lg:mx-0">
            {isClient && (
              <div
                className="relative w-full pb-[100%] sm:pb-[75%] lg:pb-[100%] golden-glow"
                onMouseEnter={() => handleMouseEnter('right')}
                onMouseLeave={() => handleMouseLeave('right')}
              >
                <motion.img
                  src="https://images.unsplash.com/photo-1583813939202-6acb4d402e22?q=80&w=2010&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Team member 2"
                  className={`absolute inset-0 rounded-lg shadow-md w-full h-full object-cover transition-transform duration-500 ${
                    hoveredRight ? 'transform-3d-hover' : 'transform-3d-default'
                  }`}
                />
              </div>
            )}
          </div>
        </div>
      </motion.section>

      <style jsx global>{`
        .perspective {
          perspective: 776px;
        }
        .transform-3d-default {
          transform: rotateX(26deg) rotateY(36deg) rotateZ(-15deg);
        }
        .transform-3d-hover {
          transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
        }
      `}</style>
{/*Section 2*/}
<div className="min-h-screen bg-black text-gray-100 py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
  <AboutSkill/>
  </div>
    </div>
  );
}